import React from 'react';

// A KOIN amount rendered with the koin logo as the unit symbol. `value` is the
// already-formatted amount; the icon scales with the surrounding font size.
export default function KoinAmount({
    value,
    symbolFirst = false,
    className = '',
    iconClassName = '',
}) {
    const symbol = (
        <img
            src="/img/koin_logo.png"
            alt="KOIN"
            className={'inline-block h-[1em] w-[1em] shrink-0 object-contain ' + iconClassName}
        />
    );
    return (
        <span className={'inline-flex items-center gap-1 ' + className}>
            {symbolFirst && symbol}
            {value}
            {!symbolFirst && symbol}
        </span>
    );
}
